export const socialmediapreviewConstants = {
    GET_REQUEST: 'SOCIALMEDIAPREVIEW_GET_REQUEST',
    GET_SUCCESS: 'SOCIALMEDIAPREVIEW_GET_SUCCESS',
    GET_FAILURE: 'SOCIALMEDIAPREVIEW_GET_FAILURE',
    GET_FAILURE_DONE: 'SOCIALMEDIAPREVIEW_GET_FAILURE_DONE'
}